import React from 'react'
import ReactDOM from 'react-dom'
import './styles/index.scss'
import "react-perfect-scrollbar/dist/css/styles.css"
import App from './App'
import reportWebVitals from './reportWebVitals'
import rjLogger from 'react-rocketjump/logger'
import CssBaseline from '@material-ui/core/CssBaseline'

rjLogger()

ReactDOM.render(
  <React.StrictMode>
    <>
      <CssBaseline />
      <App />
    </>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
